var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongCommand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6h4v4H6V6zM2.5 4.25c0-.966.784-1.75 1.75-1.75v0C5.216 2.5 6 3.284 6 4.25V6H4.25A1.75 1.75 0 012.5 4.25v0zM2.5 11.75c0 .966.784 1.75 1.75 1.75v0A1.75 1.75 0 006 11.75V10H4.25a1.75 1.75 0 00-1.75 1.75v0zM13.5 4.25a1.75 1.75 0 00-1.75-1.75v0A1.75 1.75 0 0010 4.25V6h1.75a1.75 1.75 0 001.75-1.75v0zM13.5 11.75a1.75 1.75 0 01-1.75 1.75v0A1.75 1.75 0 0110 11.75V10h1.75v0c.966 0 1.75.784 1.75 1.75v0z",
    stroke: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_command.c09f9232.svg";
export { SvgTongyongCommand as ReactComponent };